import { addDays, formatDate } from "best-common-react";
import { DateTime } from "luxon";

export const today = new Date();

export const yesterday = addDays(today, -1) as Date;

export const tomorrow = addDays(today, 1) as Date;

const ISO_CALENDAR_DAY = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * Formats metadata fields that represent a calendar day (film date, birthday), not a clock instant.
 * JSON often sends ISO date-only strings (`YYYY-MM-DD`). `new Date("YYYY-MM-DD")` is UTC midnight,
 * so `formatDate` in a US timezone can show the previous calendar day. We parse the date part and
 * build a Luxon value on the user's local calendar so the displayed day matches roster/search data.
 */
export function formatMetadataCalendarDate(value: unknown): string {
  if (value == null || value === "") return "";
  const trimmed = String(value).trim();
  const datePart = trimmed.split("T")[0];
  const match = ISO_CALENDAR_DAY.exec(datePart);
  if (match) {
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const dt = DateTime.fromObject({ year, month, day }, { zone: "local" });
    if (!dt.isValid) return "";
    return formatDate(dt);
  }
  const instant = new Date(trimmed);
  if (Number.isNaN(instant.getTime())) return "";
  return formatDate(DateTime.fromJSDate(instant).toUTC());
}
